/**
 * Checks that the value meets the criteria of one or more of the given validator functions.
 * @typeparam T The type of the value.
 * @param validators The validator functions that the value must be valid for.
 */
export const validateAny = (validators) => {
    if (validators.length === 0) {
        throw new Error('At least one validator function must be provided.');
    }
    return (value, logger, logLabel) => {
        const logMessages = [];
        const addLogMessage = (message) => logMessages.push(message);
        const valid = validators.some(validator => validator(value, addLogMessage, logLabel));
        if (!valid) {
            logger(`${logLabel} must meet at least one of the following criteria:\n- ${logMessages.join('\n- ')}`);
        }
        return valid;
    };
};
//# sourceMappingURL=any.js.map